import styled from 'styled-components';
import React, { useEffect } from 'react';
import { Close as CloseIcon } from '@material-ui/icons';
import { Dialog as MaterialDialog, Grid, Portal, Link } from '@material-ui/core';
import { Alert, ElasticTheme, palette, Typography } from '@dev/ee-components';
import { HistoryBackAction } from '@/services/hooks/useHistoryBackAction';
import { Trans, useTranslation } from 'react-i18next';
import { useSecurity } from '@/services/hooks/useSecurity';
import { links } from '@/services/dictionaries/links';
import { FormMultiDoubleOptInTemplatesGalleryList } from './components/FormMultiDoubleOptInTemplatesGalleryList';
import { closeGalleryAction, ModalStateAction } from '../../state';

const CloseIconContainer = styled.div`
    width: 100%;
    height: 68px;
    svg {
        fill: #718096;
        top: 24px;
        right: 24px;
        position: absolute;
        cursor: pointer;
    }
`;

const Overlay = styled.div`
    background: ${palette.snow[1]};
    height: max-content;
    min-height: 100vh;

    .MuiContainer-root {
        padding-top: 0px;
    }
`;

const AlertWrapper = styled.div`
      padding: 60px 16px 0 16px;
`;

interface FormMultiDoubleOptInTemplatesGalleryProps {
    dispatchModalState: React.Dispatch<ModalStateAction<any>>,
    historyBackAction?: HistoryBackAction
}

export const FormMultiDoubleOptInTemplatesGallery = ({ dispatchModalState, historyBackAction }: FormMultiDoubleOptInTemplatesGalleryProps): JSX.Element => {
    const { t } = useTranslation();
    const { isReseller } = useSecurity();

    useEffect(() => {
        historyBackAction?.pushBackCallback(closeGallery)
    }, []);

    const closeGallery = (): boolean => {
        dispatchModalState(closeGalleryAction);
        return true;
    };
    
    const clickCloseButton = (): void => {
        historyBackAction.popAndExecuteBackCallback();
    };

    // scroll container have to be added as query selector string (DOM node mentioned in react-lazyload documentation doesn't work)
    const galleryScrollContainerId = 'galleryScrollContainer';

    return (
        <Portal>
            <MaterialDialog open fullScreen scroll="body" id={galleryScrollContainerId} style={{ zIndex: ElasticTheme.zIndex.modal + 1 }}>
                <Overlay>
                    <CloseIconContainer>
                        <CloseIcon fontSize={'large'} onClick={clickCloseButton} />
                    </CloseIconContainer>
                    <Grid container justifyContent="center" style={{ padding: '0px 16px' }}>
                        <Grid item xs={12} sm={12} style={{ maxWidth: 1170, paddingBottom: 16 }}>
                            <AlertWrapper>
                                <Alert
                                    severity="warning"
                                    body={
                                        <Typography variant="body1">
                                            {t('activationtemplatesinfo')}{' '}
                                            {!isReseller && (
                                                <Trans
                                                    i18nKey="moreaboutactivationtemplates"
                                                    components={{
                                                        url: <Link href={links.createActivationTemplate} target="_blank" />,
                                                    }}
                                                />
                                            )}
                                        </Typography>
                                    }
                                />
                            </AlertWrapper>
                            <FormMultiDoubleOptInTemplatesGalleryList dispatchModalState={dispatchModalState} historyBackAction={historyBackAction}/>
                        </Grid>
                    </Grid>
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
};
